import time_work from './appIcons/time_work.svg'
import time_break from './appIcons/time_break.svg'
import video from './appIcons/videocam-icon-24px.svg'

export const AppIcons = {
    time_work,
    time_break,
    video
}